module.exports = __webpack_public_path__ + "22a6a0b4d0a4c237bd198504634ba5ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slideshow/12.jpg
// module id = 282
// module chunks = 0